import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["defaultValue", "use"];
import { CurrencyInput } from 'foundations-components/transitional/components/CurrencyInput';
import { useIsUngatedForDisplayOptimizedFormControl } from '../v2/hooks/useIsUngatedForDisplayOptimizedFormControl';
import UICurrencyInput from 'UIComponents/input/UICurrencyInput';
import { createTokenizedComponent, withoutClassName } from './helpers';
import { parseNumericValue } from '../utils/parseNumericValue';
import { jsx as _jsx } from "react/jsx-runtime";
export let _capturedPropsForTesting = {};
function safeParseNumber(value) {
  var _parseNumericValue;
  return (_parseNumericValue = parseNumericValue(value)) !== null && _parseNumericValue !== void 0 ? _parseNumericValue : undefined;
}
const TokenizedUICurrencyInput = createTokenizedComponent(UICurrencyInput);
export default function CurrencyInputAdapter(_ref) {
  let {
      defaultValue,
      use
    } = _ref,
    commonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isUngatedForDisplayOptimizedFormControl = useIsUngatedForDisplayOptimizedFormControl();
  if (isUngatedForDisplayOptimizedFormControl) {
    const rest = withoutClassName(commonProps);
    _capturedPropsForTesting = Object.assign({
      defaultValue,
      use
    }, rest);
    return /*#__PURE__*/_jsx(CurrencyInput, Object.assign({
      "data-test-id": "CurrencyInput",
      defaultValue: defaultValue,
      use: use
    }, rest));
  }
  const adaptedDefaultValue = typeof defaultValue === 'string' ? safeParseNumber(defaultValue) : defaultValue;
  const adaptedUse = use === 'default' || use === 'on-dark' ? use : undefined;
  _capturedPropsForTesting = Object.assign({
    defaultValue: adaptedDefaultValue,
    use: adaptedUse
  }, commonProps);
  return /*#__PURE__*/_jsx(TokenizedUICurrencyInput, Object.assign({
    "data-test-id": "UICurrencyInput",
    defaultValue: adaptedDefaultValue,
    use: adaptedUse
  }, commonProps));
}